import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import AddGifts from './AddGifts';
import EditGift from './EditGift';
import ShowGifts from '../components/ShowGifts';

function GiftIdeas() {  
  const [addGift, setAddGift] = useState(false);
  const [editGift, setEditGift] = useState(null); // New state for editing

  return (
    <div>
      <Helmet>
        <title>Gift Ideas | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {addGift ? (
        <AddGifts setAddGift={setAddGift} />
      ) : editGift ? (
        <EditGift giftId={editGift} setEditGift={setEditGift} /> // Pass the gift ID to EditGift
      ) : (
        <div className=''>
          <div className='flex items-center justify-between'>
            <div>
              <h1 className="text-3xl font-bold mb-4">Gift Ideas</h1>
              <p>Gift Ideas List</p>
            </div>
            <button onClick={() => setAddGift(true)} className='btn-primary'>
              Add Gift
            </button>
          </div>
          <ShowGifts setEditGift={setEditGift} /> {/* Pass setEditGift to ShowGifts */}
        </div>
      )}
    </div>
  );
}

export default GiftIdeas;
